






import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';

@Component({
  components: {AmetrasTextAreaFieldTemplate},
  mixins: [BindAttrs]
})
export default class AmetrasBase64FieldWrapper extends Vue {

  @Prop() value!: string;

  internalValue: string | null = null;
  listeners: Record<string, any> = {};

  created() {
    if (this.value) {
      this.internalValue = atob(this.value);
    }
    this.listeners = {
      input: (newValue: string) => {
        this.$emit('input', btoa(newValue));
      },
      change: (newValue: string) => {
        this.$emit('change', btoa(newValue));
      }
    };
  }

  @Watch('value') modelChanges(
      newValue: string,
      oldValue: string
  ) {
    if (newValue !== oldValue) {
      this.internalValue = atob(newValue);
    }
  }

}

